// extracted by mini-css-extract-plugin
export default {"container":"layout_container__0OWh8","main":"layout_main__K9HKJ"};